import { Row, Col, Breadcrumb } from "react-bootstrap";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { IRequestForInformation } from "../../../api/RequestForInformation";
import { GetLicenseeReturnPageUrl } from "../../routeFactory";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  requestForInformation: IRequestForInformation;
}

const BreadCrumbs = ({
  licenceProfile,
  requestForInformation,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${requestForInformation.profileNo}`}
        >
          {licenceProfile.organisation} - {requestForInformation.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${requestForInformation.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={GetLicenseeReturnPageUrl(
            requestForInformation.profileNo,
            requestForInformation.licenseesubmisionid
          )}
        >
          {requestForInformation.licensee_return_reference}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          {requestForInformation.reference}
        </Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
